import getSelectorsToHandle from './selectorsToHandle';
import onPage from '../../events/form/onPage';

const handleDynamicForms = (win, e) => {
	const eventObjects = [];
	// arrow function okay here as form.onPage does not use 'this'
	const $content = $(e.target);
	$content
		.find(getSelectorsToHandle(win).formOnPage)
		.each((_index, element) => {
			const eventObject = onPage(win, element);
			if (eventObject) {
				eventObjects.push(eventObject);
			}
		});
	// return undefined to indicate no eventObjects were found
	return eventObjects.length > 0 ? eventObjects : undefined;
};

export default handleDynamicForms;
